module.exports = __webpack_public_path__ + "static/img/IMG_20241025_115106.c38ee833.jpg";